(function (app) {
    app.constant('covid19Constant', {
        //quick links downloads
        quickLinks: [
            {
                order: 0,
                title: 'Download Our Best Practices Whitepaper',
                date: new Date(2020, 3, 21),
                url: '/Documents/Best-Practices-Guide.pdf'
            },
            {
                order: 5,
                title: 'Navigating Your Way Back Package',
                date: new Date(2020, 4, 21),
                url: '/Documents/Navigating_Your_Way_Back_Package.pdf'
            }
        ],

        //main content on covid
        categories: [
            {
                order: 0,
                title: 'Marketing',
                subcategories:
                    [{
                        order: 0,
                        title: 'Seminars and Webinars',
                        date: new Date(2020, 3, 22),
                        contentType: 'text',
                        description: 'Below are resources to help create alternatives to live events.',
                        links:
                            [
                                {
                                    order: 0,
                                    date: new Date(2020, 3, 9),
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: 'Download Mass Media Solutions',
                                    url: '/Documents/MMG-Webinar-Marketing.pdf'
                                },
                                {
                                    order: 5,
                                    date: new Date(2020, 3, 7),
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: 'Download phone script on how to cancel your seminar',
                                    url: '/Documents/PROSPECTING_PHONE_Script_Workshop_Cancellation.docx'
                                },
                                {
                                    order: 10,
                                    date: new Date(2020, 3, 7),
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: 'Download email template on how to cancel your seminar',
                                    url: '/Documents/PROSPECTING_EMAIL_Script_Workshop_Cancellation.docx'
                                },
                                {
                                    order: 15,
                                    date: new Date(2020, 3, 7),
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: 'Learn more about WebinarConnect by Leading Response',
                                    url: 'Documents/LATEST_Leading_Response_Webinar_Connect.pdf'
                                },
                                {
                                    order: 20,
                                    date: new Date(2020, 3, 7),
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: 'Download LeadJig/Acquire Solutions',
                                    url: '/Documents/LeadJigDigital.pdf'
                                },
                                {
                                    order: 25,
                                    date: new Date(2020, 3, 7),
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: 'Download Plum Solutions',
                                    url: '/Documents/Plum_Resources.pdf'
                                },
                                {
                                    order: 30,
                                    date: new Date(2020, 3, 10),
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: 'Download Whiteglove Solutions Here',
                                    url: '/Documents/Virtual_Seminars_-_White_Glove_5B1_5D.pdf'
                                },
                                {
                                    order: 35,
                                    date: new Date(2020, 3, 22),
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: 'Click Here for a Webinar Comparison Sheet',
                                    url: '/Documents/Virtual_Offerings_Comparison.pdf'
                                }
                            ]
                    },
                    {
                        order: 10,
                        title: 'Video',
                        date: new Date(2020, 5, 9),
                        contentType: 'text',
                        description: 'Broadcast live on Facebook Live or send a quick Bomb Bomb video to engage your audience with the latest news, relevant financial tips, local events and more.',
                        links:
                            [{
                                order: 10,
                                date: new Date(2020, 3, 16),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'download the CARES Act video script',
                                url: '/Documents/Cares_Act_VideoScript.docx'
                            },
                            {
                                order: 20,
                                date: new Date(2020, 2, 27),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Learn how to go live on Facebook',
                                url: 'https://www.facebook.com/help/1636872026560015'
                            },
                            {
                                order: 30,
                                date: new Date(2020, 2, 27),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Learn more about Bomb Bomb',
                                url: 'https://bombbomb.com/c/'
                            },
                            {
                                order: 40,
                                date: new Date(2020, 2, 27),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Leading Response PSA Script Template',
                                url: 'Documents/Advisor_Prospecting_PSA_Script.docx'
                            },
                            {
                                order: 50,
                                date: new Date(2020, 2, 27),
                                featured: false,
                                iconClass: 'fig-play-circle',
                                title: 'Learn How to Look More Professional on Video',
                                url: 'https://www.linkedin.com/learning/executive-presence-on-video-conference-calls/your-video-conference-presence'
                            },
                            {
                                order: 60,
                                date: new Date(2020, 2, 27),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Coronavirus & Use of Riskalyze Video Script Template',
                                url: '/Documents/VIDEO_SCRIPT_Riskalyze.docx'
                            },
                            {
                                order: 65,
                                date: new Date(2020, 5, 9),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Phase 2 CARES ACT Video Script',
                                url: '/Documents/Phase2COVID_Cares_Act_VideoScript_(1).docx'
                            }]
                    },
                    {
                        order: 1,
                        title: 'One-on-One Appointment Solutions',
                        date: new Date(2020, 2, 24),
                        contentType: 'text',
                        description: 'Need new appointments but can’t host events? These concierge services allow quality responders to book appointments directly on your calendar through mailers and digital solutions.',
                        links:
                            [{
                                order: 10,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Learn more about Leading Response Solutions',
                                url: 'Documents/Leading_Response_Seminar_Marketing_Alternatives.pdf'
                            },
                            {
                                order: 20,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Learn more about Melissa Graves Solution',
                                url: 'Documents/Melissa_Graves_One-On-One_Appt_Setting.pdf'
                            },
                            {
                                order: 30,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Learn more about LeadJig/Acquire Solutions',
                                url: 'Documents/LeadJigDigital.pdf'
                            },
                            {
                                order: 40,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Learn more about Plum Solution',
                                url: 'Documents/Plum_Resources.pdf'
                            }]
                    },
                    {
                        order: 30,
                        title: 'Website',
                        date: new Date(2020, 5, 8),
                        contentType: 'text',
                        description: 'Keep your clients and prospects fully updated on any changes to your business by using these useful tools.',
                        links:
                            [{
                                order: 0,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Learn how to update your Google business listing',
                                url: 'https://support.google.com/business/answer/3039617?visit_id=637199748405826764-2352763689&rd=1'
                            },
                            {
                                order: 10,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download COVID-19 Website Announcement Template',
                                url: 'Documents/WEBSITE_Script_Virtual_Meetings.docx'
                            },
                            {
                                order: 20,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Website Pop-Up Images',
                                url: 'Documents/WEBSITE_Pop_Ups.docx'
                            },
                            {
                                order: 20,
                                date: new Date(2020, 5, 9),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Phase 2 Website Announcement Template',
                                url: 'Documents/Phase2Covid_WEBSITE_Script_Virtual_Meetings_(8).docx'
                            }]
                    },
                    {
                        order: 40,
                        title: 'Email',
                        date: new Date(2020, 5, 9),
                        contentType: 'text',
                        description: 'Use an email automation tool to connect with your clients and prospects about state of market updates, request one-on-one appts, weekly updates and more.',
                        links:
                            [
                                {
                                    order: 0,
                                    date: new Date(2020, 2, 24),
                                    featured: false,
                                    iconClass: 'fig-web',
                                    title: 'Learn more about Constant Contact',
                                    url: 'https://www.constantcontact.com/email-marketing'
                                },
                                {
                                    order: 10,
                                    date: new Date(2020, 2, 24),
                                    featured: false,
                                    iconClass: 'fig-web',
                                    title: 'Sign Up for Constant Contact',
                                    url: 'https://www.constantcontact.com/signup.jsp'
                                },
                                {
                                    order: 20,
                                    date: new Date(2020, 2, 24),
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: 'Download COVID-19 Email Announcement Template',
                                    url: '/Documents/WEBSITE_Script_Virtual_Meetings.docx'
                                },
                                {
                                    order: 25,
                                    date: new Date(2020, 3, 8),
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: 'Download Best Practices for Email Communication During Crisis',
                                    url: '/Documents/Email_Marketing_Tips_In_Crisis_Guide.pdf'
                                },
                                {
                                    order: 30,
                                    date: new Date(2020, 5, 9),
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: 'Download Phase 2 Email Drip Campaign',
                                    url: '/Documents/Phase2COVID_CLIENT_NURTURING_EMAIL_Script.docx'
                                }
                            ]
                    },
                    {
                        order: 50,
                        title: 'Social Media',
                        date: new Date(2020, 5, 9),
                        contentType: 'text',
                        description: 'Create brand awareness on social media. This allows you to stay connected with your current client base, while also prospecting and getting your brand out there.',
                        links:
                            [{
                                order: 0,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Learn more about Facebook business page',
                                url: 'https://www.facebook.com/business/help/461775097570076?id=939256796236247'
                            },
                            {
                                order: 10,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Learn how to go live on Facebook',
                                url: 'https://www.facebook.com/help/1636872026560015'
                            },
                            {
                                order: 20,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Learn how to build & increase brand awareness on LinkedIn',
                                url: 'https://business.linkedin.com/marketing-solutions/success/brand-awareness'
                            },
                            {
                                order: 30,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Website Pop-Up Images',
                                url: 'Documents/WEBSITE_Pop_Ups.docx'
                            },
                            {
                                order: 30,
                                date: new Date(2020, 5, 9),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Phase 2 Social Media Posts',
                                url: 'Documents/FIG_5.22.20_Phase2COVID-19Response_SocialPosts_FNL.docx'
                            }]
                    },
                    {
                        order: 60,
                        title: 'Reassure Your Clients',
                        date: new Date(2020, 5, 9),
                        contentType: 'text',
                        description: 'Keep your current clients comforted with this email template and phone script. Use this as a good touch base to remind them you are there for them.',
                        links:
                            [{
                                order: 0,
                                date: new Date(2020, 3, 16),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Social Posts Templates',
                                url: 'Documents/3._Social_Posts.zip'
                            },
                            {
                                order: 10,
                                date: new Date(2020, 3, 16),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Drip Emails Templates',
                                url: 'Documents/1._Drip_Emails.zip'
                            },
                            {
                                order: 10,
                                date: new Date(2020, 3, 16),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Additional Communication Scripts',
                                url: 'Documents/5._Scripts.zip'
                            },
                            {
                                order: 40,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Email Script',
                                url: 'Documents/CLIENT_NURTURING_EMAIL_Script.docx'
                            },
                            {
                                order: 60,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Phone Script',
                                url: 'Documents/CLIENT_NURTURING_PHONE_Script_Current_Clients.docx'
                            },
                            {
                                order: 65,
                                date: new Date(2020, 5, 9),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Phase 2 Connecting With Clients Phone Script',
                                url: 'Documents/Phase2COVID_CLIENT_NURTURING_PHONE_Script_Current_Clients_(2).docx'
                            },
                            {
                                order: 70,
                                date: new Date(2020, 5, 9),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Phase 2 Outbound Phone Script',
                                url: 'Documents/Phase2COVID-10Response_ClientNurturing_OutboundScript_FNL.docx'
                            },
                            {
                                order: 75,
                                date: new Date(2020, 5, 9),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Phase 2 Inbound Phone Script',
                                url: 'Documents/Phase2COVID-10Response_ClientNurturing_InboundScript_FNL.docx'
                            },
                            {
                                order: 80,
                                date: new Date(2020, 5, 9),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Phase 2 Email Drip Campaign',
                                url: 'Documents/FIG_5.22.20_COVID-19Phase2_DripCampaign_FNL.docx'
                            }]
                    }]
            },
            {
                order: 30,
                title: 'Appointments',
                subcategories: [{
                    order: 0,
                    title: 'Setting Appointments',
                    date: new Date(2020, 2, 24),
                    contentType: 'text',
                    description: 'Online schedulers provide a link to your available appointment slots. Use the link in emails, email signatures, and all digital prospecting efforts to invite someone to meet with you. Best of all—it can link straight to your calendar.',
                    links:
                        [{
                            order: 0,
                            date: new Date(2020, 2, 24),
                            featured: false,
                            iconClass: 'fig-web',
                            title: 'Watch the Calendly Tutorial',
                            url: 'https://calendly.com/?wvideo=ldm2s4ep7u'
                        },
                        {
                            order: 10,
                            date: new Date(2020, 2, 24),
                            featured: false,
                            iconClass: 'fig-web',
                            title: 'Sign Up for Calendly for Free',
                            url: 'https://calendly.com/?&utm_campaign=brand-exact&aw_adgroup=&aw_version=c&gclid=EAIaIQobChMImqfxiYii6AIVFXiGCh39pQRyEAAYASAAEgInXPD_BwE'
                        },
                        {
                            order: 20,
                            date: new Date(2020, 2, 24),
                            featured: false,
                            iconClass: 'fig-web',
                            title: 'Learn More on Timetrade',
                            url: 'https://youtu.be/OqLCjcBw-TY'
                        },
                        {
                            order: 30,
                            date: new Date(2020, 2, 24),
                            featured: false,
                            iconClass: 'fig-web',
                            title: 'Schedule a Demo with Timetrade',
                            url: 'https://www.timetrade.com/appointment-router-hp1-demo/'
                        }]
                },
                {
                    order: 10,
                    title: 'Phone & Text Solutions',
                    date: new Date(2020, 2, 24),
                    contentType: 'text',
                    description: 'Texting and calling solutions can help you send a message out to your whole database quickly.',
                    links:
                        [{
                            order: 0,
                            date: new Date(2020, 2, 24),
                            featured: false,
                            iconClass: 'fig-web',
                            title: 'Learn more about Textedly',
                            url: 'https://vimeo.com/157185193'
                        },
                        {
                            order: 10,
                            date: new Date(2020, 2, 24),
                            featured: false,
                            iconClass: 'fig-web',
                            title: 'Sign Up for Textedly',
                            url: 'https://www.textedly.com/create-account?subscription_plan=free'
                        },
                        {
                            order: 20,
                            date: new Date(2020, 2, 24),
                            featured: false,
                            iconClass: 'fig-file-text',
                            title: 'Learn more about CallFire',
                            url: 'https://youtu.be/ANzh_YCo6qY'
                        },
                        {
                            order: 30,
                            date: new Date(2020, 2, 24),
                            featured: false,
                            iconClass: 'fig-web',
                            title: 'View CallFire user guide',
                            url: 'https://www.callfire.com/help/docs/getting-started/welcome-to-callfire'
                        }]
                },
                {
                    order: 20,
                    title: 'Virtual Appointments',
                    date: new Date(2020, 2, 31),
                    contentType: 'text',
                    description: 'Use tools such as Zoom or GoToMeeting to have a virtual appointment with your prospect or client. These tools allow you to video conference, share screens, and more.',
                    links:
                        [
                            {
                                order: 15,
                                date: new Date(2020, 3, 14),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download How to Conduct Virtual Meetings & Appointments Guide',
                                url: '/Documents/C19-Virtual_Meetings_Guide-2.pdf'
                            },
                            {
                                order: 20,
                                date: new Date(2020, 2, 31),
                                featured: false,
                                iconClass: 'fig-play',
                                title: 'Watch Zoom Tutorials',
                                url: 'https://support.zoom.us/hc/en-us/articles/206618765-Zoom-Video-Tutorials'
                            },
                            {
                                order: 25,
                                date: new Date(2020, 2, 31),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Sign Up For Zoom',
                                url: 'https://zoom.us/signup'
                            },
                            {
                                order: 30,
                                date: new Date(2020, 2, 31),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Learn About GoTo Meeting',
                                url: 'https://www.youtube.com/watch?v=HKJ-Ei4z8k8'
                            },
                            {
                                order: 35,
                                date: new Date(2020, 2, 31),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Sign Up for a Free Trial of GoTo Meeting',
                                url: 'https://www.gotomeeting.com/try'
                            },
                            {
                                order: 40,
                                date: new Date(2020, 2, 31),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download How to Video Conference Like a Pro Guide',
                                url: '/Documents/How_To_Video_Conference_Like_A_Pro.pdf'
                            }]
                },
                {
                    order: 30,
                    title: 'Sharing Files Securely with Clients',
                    date: new Date(2020, 3, 22),
                    contentType: 'text',
                    description: 'Utilize a tool such as Dropbox to allow your clients to upload documents securely without having to meet in-person.',
                    links:
                        [
                            {
                                order: 0,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Learn More About Dropbox',
                                url: 'https://youtu.be/WRrBE28KTXI'
                            },
                            {
                                order: 5,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Sign Up for Dropbox',
                                url: 'https://www.dropbox.com/basic'
                            },
                            {
                                order: 10,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'View Dropbox Tutorials',
                                url: 'https://help.dropbox.com/learn/video-tutorials#save'
                            },
                            {
                                order: 15,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Learn how to send a secure upload link',
                                url: 'https://help.dropbox.com/files-folders/share/create-file-request'
                            },
                            {
                                order: 20,
                                date: new Date(2020, 3, 22),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Learn how to Scan Using Android Phone',
                                url: 'https://www.theandroidsoul.com/how-to-scan-documents-and-store-them-online-on-android/'
                            },
                            {
                                order: 25,
                                date: new Date(2020, 3, 22),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Learn how to Scan Using iPhone and iPad',
                                url: 'https://www.imore.com/how-use-document-scanner-iphone-and-ipad#marking-up-scanned-documents'
                            }
                        ]
                }]
            },
            {
                order: 40,
                title: 'Applications',
                subcategories: [{
                    order: 0,
                    title: 'e-Applications',
                    date: new Date(2020, 3, 3),
                    contentType: 'text',
                    description: 'E-Applications are a streamlined way to conduct business electronically. Alleviate in-person meeting stress and virtually eliminate NIGOs.',
                    links:
                        [{
                            order: 0,
                            date: new Date(2020, 3, 3),
                            featured: false,
                            iconClass: 'fig-play-circle',
                            title: 'Watch FireLight Tutorial (Annuities/Life)',
                            url: 'https://vimeo.com/252203149/def6d69d30'
                        },
                        {
                            order: 5,
                            date: new Date(2020, 3, 3),
                            featured: false,
                            iconClass: 'fig-play-circle',
                            title: 'Watch iPipeline Tutorial (Life/LTC)',
                            url: 'https://www.customerportal.ipipeline.com/knowledgebase/igo-overview/?print=print'
                        },
                        {
                            order: 10,
                            date: new Date(2020, 3, 3),
                            featured: false,
                            iconClass: 'fig-file-text',
                            title: "Download FIG's Comprehensive eapp Guide Here",
                            url: '/Documents/eAppGuide.pdf'
                        }]
                },
                {
                    order: 10,
                    title: 'Virtually Sign an e-App',
                    date: new Date(2020, 2, 24),
                    contentType: 'text',
                    description: 'Utilizing e-applications, you are able to email your client to sign the application if an in-person meeting is not possible.',
                    links:
                        [{
                            order: 10,
                            date: new Date(2020, 2, 24),
                            featured: false,
                            iconClass: 'fig-play-circle',
                            title: 'Learn How with FireLight',
                            url: 'https://vimeo.com/263943487/460ad2f984'
                        },
                        {
                            order: 20,
                            date: new Date(2020, 2, 24),
                            featured: false,
                            iconClass: 'fig-play-circle',
                            title: 'Learn How with iPipeline',
                            url: 'https://fig.wistia.com/medias/fl3k3wzv64'
                        }]
                },
                {
                    order: 20,
                    title: 'Life & LTC Paramed Vendor Updates',
                    date: new Date(2020, 2, 24),
                    contentType: 'text',
                    description: 'Below are updates and alerts from our main paramed vendor partners.',
                    links:
                        [{
                            order: 10,
                            date: new Date(2020, 2, 24),
                            featured: false,
                            iconClass: 'fig-web',
                            title: 'View for ExamOne’s Response',
                            url: 'https://www.examone.com/examone-response-to-coronavirus-disease-2019-covid-19/'
                        },
                        {
                            order: 20,
                            date: new Date(2020, 2, 24),
                            featured: false,
                            iconClass: 'fig-web',
                            title: 'View APPS Information',
                            url: 'https://appslive.com/'
                        },
                        {
                            order: 30,
                            date: new Date(2020, 2, 24),
                            featured: false,
                            iconClass: 'fig-web',
                            title: 'View EMSI’s Response',
                            url: 'https://www.emsinet.com/company-alerts/'
                        }]
                },
                {
                    order: 0,
                    title: 'Docusign',
                    date: new Date(2020, 2, 26),
                    contentType: 'text',
                    description: 'Getting set up with a Docusign account will allow you to transfer your current paperwork to send for clients for e-signature. Note: Please ensure the carrier or company you are working with will accept a Docusign eSignature.',
                    links:
                        [{
                            order: 0,
                            date: new Date(2020, 2, 26),
                            featured: false,
                            iconClass: 'fig-web',
                            title: 'Sign Up for Docusign',
                            url: 'https://go.docusign.com/trial/productshot/?elqCampaignId=4481&utm_term=sign%20up%20for%20docusign&utm_campaign=branded_secondary&gclid=CjwKCAjwguzzBRBiEiwAgU0FT9WT8rkxafyktXrVGvJ-ilbSAb3pLmugVXuPhVi02Yc3Nh-Q_0NFFRoChhcQAvD_BwE&utm_source=google&utm_medium=cpc&utm_content=domestic_US&rflag=1'
                        },
                        {
                            order: 5,
                            date: new Date(2020, 2, 26),
                            featured: false,
                            iconClass: 'fig-web',
                            title: 'Visit the Docusign Support Center',
                            url: 'https://support.docusign.com/?_ga=2.44526308.1966305337.1585167385-63027882.1585167385&_gac=1.259124088.1585167385.CjwKCAjwguzzBRBiEiwAgU0FT9WT8rkxafyktXrVGvJ-ilbSAb3pLmugVXuPhVi02Yc3Nh-Q_0NFFRoChhcQAvD_BwE'
                        }]
                }]
            },
            {
                order: 50,
                title: 'Business Process Optimization',
                subcategories:
                    [{
                        order: 0,
                        title: 'Engaging with Office Staff',
                        date: new Date(2020, 2, 24),
                        contentType: 'text',
                        description: 'Operating a business 100% virtually is a difficult task. Learn more on best practices for how to handle your business in this new time.',
                        links:
                            [{
                                order: 0,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Learn 9 Tips to Engage and Communicate with Remote Staff Members',
                                url: '/Documents/9_Tips_to_Engage.pdf'
                            },
                            {
                                order: 10,
                                date: new Date(2020, 2, 24),
                                featured: false,
                                iconClass: 'fig-play-circle',
                                title: 'Learn how to use Slack for real time communication with remote teams',
                                url: 'https://youtu.be/EYqxQGmQkVw'
                            }]
                    }]
            }
        ],

        //FAQs modal content
        faqs: [
            {
                order: 10,
                title: 'Who do we need to call or communicate with?',
                date: new Date(2020, 2, 24),
                contentType: 'text',
                description: [
                    'Both your “A” and “B” clients, strategic alliances, and potential new partners. Ask how they are responding to the crisis. Send them updates and communicate regularly, even if there isn’t new information. Make the message personal.',
                    'No one will look back at this time and say, “My planner was so annoying with all the encouraging emails checking in on me.” When people are isolated, over-communication is more crucial than ever.'
                ],
                links: []
            },
            {
                order: 20,
                title: 'I’m not getting a lot of calls from my clients, and that’s good. They understand our planning process and we’ve prepared for these types of events. But my AUM is declining from losses in the market, and I stand to lose $10,000 per month in fees.',
                date: new Date(2020, 2, 24),
                contentType: 'text',
                description: [
                    'We understand how that can be upsetting. However, remember what you tell clients when the going gets tough. Stick with the plan! Don’t start thinking you have to change your marketing to 100% annuities to generate commissions.',
                    'This will pass. It just takes time. You’ve been deliberately adding fee-based planning to create trails and longer income streams. It would be short-sighted to undo what you’ve been working on. The fee business, although at times volatile, will transform your business and increase enterprise value. You’re in it for the long haul, so keep pressing ahead. Have confidence in your process. Sell your complete offering, including wealth management.'
                ],
                links: []
            },
            {
                order: 30,
                title: 'I’ve got a workshop soon and people are canceling. Should I postpone it? What other options do I have?',
                date: new Date(2020, 2, 24),
                contentType: 'text',
                description: [
                    'Now is the perfect time to test out a virtual workshop! Using GoToMeeting or Zoom, you can host a video conference call or a webinar and share content on your screen to attendees. Let the participants know you’re trying to be respectful of the health crisis but still provide a valuable service to them. Ask them to participate in the experiment. Send out a short follow-up survey (five questions max) to get feedback.',
                    'You may want to incorporate this into your routine or use it to adjust certain aspects of your presentation. No one will be upset if you have issues with the technology or it’s not as smooth as you would have hoped. They’ll appreciate that you took the time to be flexible and attempt to find new ways to serve them. '
                ],
                links: []
            },
            {
                order: 40,
                title: 'I’m seeing a slowdown in activity and I’m concerned about my staff. Do I pay them? Can I reduce hours or maybe even have layoffs? Will the government help offset my potential losses with any of these programs they’re announcing?',
                date: new Date(2020, 2, 30),
                contentType: 'text',
                description: [
                    'Let’s try to unpack this a bit. First, the government’s response to this economic situation is fluid. It’s changing hour by hour and we don’t expect any clarity for some time yet. Consult with your state employment agency to see what insights they may have, but we suspect they don’t know much more than you do at this point.',
                    'Here’s what we can tell you: your staff wants and needs assurances that you’re aware of their hardship and will work with them as best you can. You must be transparent. Tell them that you want to avoid any reduced hours and layoffs, but it may come to that if the situation persists. For now, everyone will be tasked with doing all the tasks that we tend to put off or ignore when they’re busy. So basic tasks will take over until you can ramp back up.',
                    'When was the last time you updated workflows? Have you changed any processes or added any new products that require updates to the workflows? Maybe you can schedule a demo for a piece of software that you’ve been interested in. How about marketing collateral, is yours fresh or could you use updated content? Can you make changes to your website? Perhaps you can start preparing for annual reviews or RMDs. Get going on these activities so you’re ahead of the game when business starts to accelerate again. And it will accelerate!'
                ],
                links: [
                    {
                        title: 'View 19 Financial Assistance Programs for Small Businesses',
                        url: 'https://www.zenefits.com/workest/the-big-list-of-covid-19-financial-assistance-programs-for-small-businesses-by-state/'
                    }
                ]
            }
        ],

        //FIG message wistia video
        figMessages: [
            {
                mediaType: 'wistia',
                date: new Date(2020, 3, 17),
                url: 'wistia_async_h3lg97acg6',
                links:
                    []
            },
            {
                mediaType: 'wistia',
                date: new Date(2020, 3, 10),
                url: 'wistia_async_kmu72wuvf9',
                links:
                    []
            },
            {
                mediaType: 'wistia',
                date: new Date(2020, 3, 3),
                url: 'wistia_async_iivymz2cs7',
                links:
                    []
            },
            {
                mediaType: 'wistia',
                date: new Date(2020, 2, 27),
                url: 'wistia_async_g9y4td2eu1',
                links:
                    [{
                        order: 10,
                        title: 'Visit SBA.Gov',
                        url: 'https://www.sba.gov/'
                    },
                    {
                        order: 20,
                        title: 'Download the Families First Coronavirus Response Act Summary',
                        url: '/Documents/Families-First-Coronavirus-Response-Act-Summary.pdf'
                    }]
            },
            {
                mediaType: 'wistia',
                date: new Date(2020, 2, 20),
                url: 'wistia_async_v6r1iznure',
                links: []
            },
            {
                mediaType: 'wistia',
                date: new Date(2020, 2, 16),
                url: 'wistia_async_ufi0x9ztl8',
                links: []
            }
        ],

        //carrier updates side pane content
        carrierUpdates: [
            {
                title: 'AIG',
                subcategories:
                    [{
                        order: 0,
                        title: 'AIG',
                        date: new Date(2020, 3, 9),
                        description: '',
                        links:
                            [
                                {
                                    order: 0,
                                    date: new Date(2020, 3, 9),
                                    featured: false,
                                    iconClass: 'fig-web',
                                    title: 'View AIG\'s Underwriting Updates',
                                    url: 'https://live.cloud.api.aig.com/life/connext-fdm/download/100AicF6FGkgO9MMYvefTIwGZAnN03P_jgKVAgdWY7vk_mJnG7cR8wBHdzjZ7tKgEyVtBfjqBs6kTHdUgAYYgIxYtA'
                                },
                                {
                                    order: 10,
                                    featured: false,
                                    iconClass: 'fig-web',
                                    title: 'View AIG Updates',
                                    url: 'http://app.e1.aig.com/e/es?s=1811892392&e=36147&elqTrackId=95beca11f24741858db5a12349810efc&elq=5dfd0d70657047e5b0d7f5df661e097f&elqaid=4811&elqat=1'
                                },
                                {
                                    order: 15,
                                    featured: false,
                                    iconClass: 'fig-web',
                                    title: 'Learn More About AIG Life Insurance',
                                    url: 'http://www.aig.com/lifeiq'
                                },
                                {
                                    order: 30,
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: 'Download AIG\'s Virtual Sales Guidelines',
                                    url: 'Documents/Compliance_Bulletin_-_Virtual_Sales.pdf'
                                }]
                    }]
            },
            {
                title: 'Allianz',
                subcategories:
                    [{
                        order: 0,
                        title: 'Allianz',
                        date: new Date(2020, 3, 7),
                        description: '',
                        links:
                            [{
                                order: 5,
                                date: new Date(2020, 3, 7),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'View Ease of Doing Business Update',
                                url: 'https://connect.allianzlife.com/pub/sf/ResponseForm?_ri_=X0Gzc2X%3DYQpglLjHJlTQGivaHhLbBwzf0NWSJgJginzbzdgt6AkzekKkIzgYOYoraGsiTmzezeTRM8dgbYSVXMtX%3DYQpglLjHJlTQGivaHhLbBwzf0NWSJgJginzb5M2zdbza4FzcDoBJ5eKNpOGCntTa9cWCWILFf&_ei_=EolaGGF4SNMvxFF7KucKuWNaSRN04s07bSlUTEC_qXtRR7wHZj1HgtxF8BrvHfMSRG9e0fSLJy9y-heFYyqDSAICkZMSEKgKYC5AaHXZHirsFf_FeUw6crGbNtBiO8dQwrf46ujl_nN7gy3-UDhfzUZoHw&_di_=jhd1dpruae8c0ahjqpsngtlsabbhn05r6p06ji153kel06al59hg'
                            },
                            {
                                order: 10,
                                date: new Date(2020, 2, 25),
                                featured: false,
                                iconClass: 'fig-play-circle',
                                title: 'Listen to Allianz Forum Call',
                                url: 'https://www.brainshark.com/allianzlifedtt/vu?pi=zIuzSFwbtzZDftz0'
                            },
                            {
                                order: 15,
                                date: new Date(2020, 2, 25),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download Allianz’s Virtual Reimbursement Program',
                                url: '/Documents/Allianz_Virtual_Meeting_Reimbursement_Program.pdf'
                            }]
                    }]
            },
            {
                title: 'American Equity',
                subcategories:
                    [
                        {
                            order: 0,
                            title: 'American Equity',
                            date: new Date(2020, 3, 29),
                            description: '',
                            links:
                                [
                                    {
                                        order: 0,
                                        date: new Date(2020, 3, 29),
                                        featured: false,
                                        iconClass: 'fig-file-text',
                                        title: 'Learn more about e-delivery',
                                        url: '/Documents/AEL e-delivery.pdf'
                                    },
                                    {
                                        order: 10,
                                        date: new Date(2020, 2, 26),
                                        featured: false,
                                        iconClass: 'fig-web',
                                        title: 'View Requirements for Virtual Sales',
                                        url: 'http://view.email.american-equity.com/?qs=6c1ef4765ac91635ca2634c3f38fba6c220d7c7e549c64067cccc1727e44f95a779218418e3fe8d2b418ca7d43a35754c015f1efdcd5373648fc2144710029c1b24ade9eb56e91d4b6c39be0f6f36572'
                                    }
                                ]
                        }
                    ]
            },
            {
                title: 'ANICO',
                subcategories:
                    [{
                        order: 0,
                        title: 'ANICO',
                        date: new Date(2020, 2, 26),
                        description: '',
                        links:
                            [{
                                order: 0,
                                date: new Date(2020, 2, 26),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'View ANICO’s FAQ Page',
                                url: 'https://img.anicoweb.com/wps/wcm/connect/anicoweb/42b03c73-60c3-49eb-bd39-8e40bc666265/IMG22562.pdf?MOD=AJPERES&CVID=n3V9HxE&WT.mc_id='
                            },
                            {
                                order: 10,
                                date: new Date(2020, 2, 26),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Learn More About Accelerated Underwriting',
                                url: 'http://view.mail.independentmarketinggroup.net/?qs=48cfd8cbaa09a75a1bc962f59fad2854c41153f522c30c67f99ce8376a0847b68c6f35ad52ee8fefb61be0f385f6b4fe840990b366096a70a110ccdf64344e8d373cb37a4131bf6565916ddc9afaa46b'
                            }]
                    }]
            },
            {
                title: 'Athene',
                subcategories:
                    [{
                        order: 0,
                        title: 'Athene',
                        date: new Date(2020, 3, 6),
                        description: '',
                        links:
                            [{
                                order: 0,
                                date: new Date(2020, 3, 6),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'Guidelines for Doing Business Virtually',
                                url: 'https://p.widencdn.net/3bfguz/52269'
                            }]
                    }]
            },
            {
                order: 30,
                title: 'Equitable Life',
                subcategories:
                    [{
                        order: 0,
                        title: 'Equitable Life',
                        date: new Date(2020, 2, 31),
                        description: '',
                        links:
                            [{
                                order: 0,
                                date: new Date(2020, 2, 31),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Learn More About Accumulation Streamlined Underwriting Program',
                                url: '/Documents/Accum_Streamlined_Under_Program.pdf'
                            },
                            {
                                order: 10,
                                date: new Date(2020, 2, 31),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Learn More About the Customer Contingency Plan',
                                url: '/Documents/Customer_Contingency_Plan.pdf'
                            }]
                    }]
            },
            {
                order: 31,
                title: 'Equitrust',
                subcategories: [
                    {
                        order: 0,
                        title: 'Equitrust',
                        date: new Date(2020, 2, 25),
                        description: '',
                        links:
                            [{
                                order: 0,
                                date: new Date(2020, 2, 25),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Learn More About Remote Sales Procedures',
                                url: 'http://click.swiftpage.marketing/vh/055-64462b20-1d04-42e5-b787-1b8a303ebc64?e=naagcadnabuqa3aaoqag6adoaaxaa3ian4aheadbabwaaziaomaeaadgabuqazyanuagcadsabvqaziaoqagsadoabtqalqammag6adnaa======'
                            },
                            {
                                order: 10,
                                date: new Date(2020, 2, 25),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'View Equitrust’s Business Updates',
                                url: 'https://click.swiftpage.marketing/vh/055-fe8b83f1-7916-464b-9620-1994d14133c0?e=neag4adgabxqaqaamyagsadhabwqayiaoiagwadfab2aa2ianyagoaboabrqa3yanuaa===='
                            },
                            {
                                order: 20,
                                date: new Date(2020, 2, 25),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'View Revised Guidelines for Conducting Telephone Underwriting Interviews Remotely',
                                url: 'https://click.swiftpage.marketing/vh/055-a8b6dea7-4291-44c0-ad45-258b70343a5b?e=neag4adgabxqaqaamyagsadhabwqayiaoiagwadfab2aa2ianyagoaboabrqa3yanuaa===='
                            }]
                    }]
            },
            {
                order: 32,
                title: 'Transamerica',
                subcategories:
                    [{
                        order: 0,
                        title: 'Transamerica',
                        date: new Date(2020, 3, 9),
                        description: '',
                        links:
                            [{
                                order: 0,
                                date: new Date(2020, 3, 9),
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'View Transamerica\'s General Updates',
                                url: 'https://pub.s4.exacttarget.com/21f5ji30e3d?cm_ven=ExactTarget&cm_cat=20200407_254436_insurancecovid19responce_bkgga_op&cm_pla=All+Subscribers&cm_ite=VIEW+MORE&SubscriberID=217914239&MID=1402504&SubscriberKey=003F000001qBfHSIA0&BatchID=1&DataSource=20200219_208421_termconversion_ga_pr'
                            }]
                    }]
            },
            {
                order: 33,
                title: 'Lincoln Financial',
                subcategories:
                    [{
                        order: 0,
                        title: 'Lincoln Financial',
                        date: new Date(2020, 3, 8),
                        description: '',
                        links:
                            [
                                {
                                    order: 0,
                                    date: new Date(2020, 2, 27),
                                    featured: false,
                                    iconClass: 'fig-play-circle',
                                    title: "Listen to Lincoln's On-Demand Webinar for Information on Market Volatility",
                                    url: 'https://lincoln-financial.lfd.com/COV'
                                },
                                {
                                    order: 5,
                                    date: new Date(2020, 3, 8),
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: "View Lincoln MoneyGuard e-Capabilities",
                                    url: '/Documents/MG_e-Capabilities_OnePager.pdf'
                                }
                            ]
                    }]
            },
            {
                order: 35,
                title: 'Mutual of Omaha',
                subcategories:
                    [{
                        order: 0,
                        title: 'Mutual of Omaha',
                        date: new Date(2020, 3, 29),
                        description: '',
                        links:
                            [
                                {
                                    order: 0,
                                    date: new Date(2020, 3, 29),
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: 'Download LTC Policy Output Procedures',
                                    url: '/Documents/Important_Information_Regarding_LTC_Policy_Output_Procedures.pdf'
                                },
                                {
                                    order: 10,
                                    date: new Date(2020, 2, 26),
                                    featured: false,
                                    iconClass: 'fig-web',
                                    title: 'View Important Informational Updates',
                                    url: 'http://view.e.mutualofomaha.com/?qs=c4dc64d1fa414bbfed09fbee76a4f322ea868db6cd6ae96f22cfbe49e7903587c4c690f1ab3296005035c3c829264c70ae3bac35400800241db79138de548251b9f5457c80676fd4'
                                }
                            ]
                    }]
            },
            {
                order: 36,
                title: 'Nationwide',
                subcategories:
                    [
                        {
                            order: 0,
                            title: 'Nationwide',
                            date: new Date(2020, 3, 9),
                            description: '',
                            links:
                                [{
                                    order: 0,
                                    date: new Date(2020, 3, 9),
                                    featured: false,
                                    iconClass: 'fig-web',
                                    title: 'How to conduct business with Nationwide',
                                    url: 'http://view.email-nationwide.com/?qs=37331703304b2369a5a5c5d3c1e313a8253343868a872bc400b9993ceb3f6648985c507c78bdc26977402b551f167aaaa99a53a805da7d780edbfa0357088832c155568c6dcb2784b6821b3fa34cb618'
                                },
                                {
                                    order: 0,
                                    date: new Date(2020, 2, 27),
                                    featured: false,
                                    iconClass: 'fig-file-text',
                                    title: 'Download the Life Underwriting FAQs',
                                    url: 'Documents/LAM-3394AO_2020_Nationwide_Life_Underwriting_FAQs_ANNOUNCEMENT_3.27.2020-FINAL.pdf'
                                }
                                ]
                        }
                    ]
            },
            {
                order: 40,
                title: 'North American',
                subcategories:
                    [{
                        order: 0,
                        title: 'North American',
                        date: new Date(2020, 3, 7),
                        description: '',
                        links:
                            [{
                                order: 5,
                                date: new Date(2020, 3, 7),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'View Ease of Doing Business Update',
                                url: 'http://app.annuities.sfgmembers.com/e/es?s=150510139&e=13933&elqTrackId=78D8A052C380BCBFF284D754BEBE9730&elq=d6e09cffee5149bf92b74abaaa96d604&elqaid=1865&elqat=1'
                            },
                            {
                                order: 10,
                                date: new Date(2020, 3, 7),
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'View Digital Updates for North American',
                                url: 'http://app.annuities.sfgmembers.com/e/es?s=150510139&e=13640&elqTrackId=78D8A052C380BCBFF284D754BEBE9730&elq=9a8c7d7d77ab4608b43a3ee5cc5cca79&elqaid=1833&elqat=1'
                            },
                            {
                                order: 15,
                                date: new Date(2020, 3, 7),
                                featured: false,
                                iconClass: 'fig-play-circle',
                                title: 'Watch Important Updates from North American',
                                url: 'https://app.annuities.sfgmembers.com/e/es?s=150510139&e=13469&elqTrackId=78D8A052C380BCBFF284D754BEBE9730&elq=f72052fb41054974b8cfc0ef5ae82c37&elqaid=1814&elqat=1'
                            }]
                    }]
            },
            {
                order: 41,
                title: 'Protective',
                subcategories:
                    [{
                        order: 0,
                        title: 'Protective',
                        date: new Date(2020, 2, 26),
                        description: '',
                        links:
                            [{
                                order: 0,
                                featured: false,
                                iconClass: 'fig-web',
                                title: 'View Protective’s Resource Center',
                                url: 'https://www.myprotective.com/COVID-19/'
                            }]
                    }]
            },
            {
                order: 50,
                title: 'Principal',
                subcategories:
                    [{
                        order: 0,
                        title: 'Principal',
                        date: new Date(2020, 2, 26),
                        description: '',
                        links:
                            [{
                                order: 0,
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download the Underwriting Guidelines',
                                url: '/Documents/PRU_COVID-19_Underwriting_Guidelines_update.pdf'
                            }]
                    }]
            },
            {
                order: 51,
                title: 'Royal Neighbors',
                subcategories:
                    [{
                        order: 0,
                        title: 'Royal Neighbors',
                        date: new Date(2020, 2, 25),
                        description: '',
                        links:
                            [{
                                order: 0,
                                featured: false,
                                iconClass: 'fig-play-circle',
                                title: 'Watch the Special Announcement from Royal Neighbors',
                                url: 'https://vimeo.com/398964082/baeb24e438'
                            }]
                    }]
            },
            {
                order: 60,
                title: 'Reliance Standard',
                subcategories:
                    [{
                        order: 0,
                        title: 'Reliance Standard',
                        date: new Date(2020, 2, 25),
                        description: '',
                        links:
                            [{
                                order: 0,
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download the Remote Operations Updates',
                                url: 'Documents/RSL_Remote_Ops_Update.pdf'
                            },
                            {
                                order: 0,
                                featured: false,
                                iconClass: 'fig-file-text',
                                title: 'Download the Electronic Signature and Delivery Consent Form',
                                url: 'Documents/EF-3462.pdf'
                            }]
                    }]
            }
        ],

        //template. TODO: Maybe outdated
        templateCategories: [{
            order: 10,
            title: '',
            subcategories: [{
                order: 0,
                title: '',
                date: new Date(2020, 2, 24),
                contentType: 'text',
                description: '',
                links: [{
                    order: 0,
                    featured: false, iconClass: '',
                    title: '',
                    url: ''
                }]
            }]
        }],
        templateFaqs: [{
            order: 10,
            title: '',
            date: new Date(2020, 2, 24),
            contentType: 'text',
            description: [
                ''
            ],
            links: [{
                order: 0,
                featured: false, iconClass: '',
                title: '',
                url: ''
            }]
        }]
    });

    app.factory('covid19Factory', ['covid19Constant', '$q', function covid19Factory(covid19Constant, $q) {
        var service = {};

        //get total # of available links & downloads per category in the main content
        //TODO: would be better to simply calculate this internally rather than having to inject & call the service on the controllers. See: Resources/Covid19/covid19.js line 163
        service.getAssetCount = function (category) {
            var count = 0;
            category.subcategories.forEach(function (subCat) {
                if (subCat.links.length) count += subCat.links.length;
            });

            return count;
        };

        service.getLatestDate = function () {
            function _sortSubcategory(category) {
                if (!category) return;
                return _.sortBy(category.subcategories, [function (row) { return row.date; }]);
            }
            function _sortLinks(links) {
                if (!links) return;
                return _.sortBy(links, [function (row) { return row.date; }]);
            }
            function _getLatestUpdate() {
                var latestUpdates = [];
                latestUpdates.push(_sortLinks(covid19Constant.quickLinks)[covid19Constant.quickLinks.length - 1]);
                covid19Constant.categories.forEach(function (cat) {
                    latestUpdates.push(_sortSubcategory(cat)[cat.subcategories.length - 1]);
                });
                covid19Constant.carrierUpdates.forEach(function (cat) {
                    latestUpdates.push(_sortSubcategory(cat)[cat.subcategories.length - 1]);
                });
                latestUpdates.push(_.sortBy(covid19Constant.figMessages, [function (row) { return row.date; }])[covid19Constant.figMessages.length - 1]);

                latestUpdates = _.sortBy(latestUpdates, [function (row) { return row.date; }]);
                return latestUpdates[latestUpdates.length - 1];
            }

            return _getLatestUpdate().date;

        };

        //get all subcategories and links that have been updated withing a specified range
        service.getLatestAssets = function (lastAccessDate, categories) {
            var updates = {
                subcategories: [],
                links: []
            },
                cutOffDate = lastAccessDate;
            //cutOffDate = moment().subtract(numberOfDays, "days");
            categories.forEach(function (category) {
                category.subcategories.forEach(function (subcat) {
                    if (subcat.date) {
                        var subcatMoment = moment(subcat.date);
                        if (subcatMoment.isAfter(cutOffDate)) {
                            updates.subcategories = updates.subcategories.concat(subcat);
                        }
                    }
                    subcat.links.forEach(function (link) {
                        if (link.date) {
                            var linkMoment = moment(link.date);
                            if (linkMoment.isAfter(cutOffDate)) {
                                updates.links = updates.links.concat(link);
                            }
                        }
                    });
                });
            });
            return updates;
        };
        service.getLatestLinks = function (lastAccessDate, links) {
            recentLinks = [];
            cutOffDate = lastAccessDate;
            links.forEach(function (link) {
                if (link.date) {
                    var linkMoment = moment(link.date);
                    if (linkMoment.isAfter(cutOffDate)) {
                        recentLinks = recentLinks.concat(link);
                    }
                }
            });
            return recentLinks;
        };
        return service;
    }]);
})(window.app);